import * as THREE from 'three';
import { GameScene } from '../scenes/GameScene';

export abstract class BaseInputController {
  protected camera: THREE.PerspectiveCamera;
  protected gameScene: GameScene;

  constructor(camera: THREE.PerspectiveCamera, gameScene: GameScene) {
    this.camera = camera;
    this.gameScene = gameScene;
  }

  // Getters for protected properties
  public getCamera(): THREE.PerspectiveCamera {
    return this.camera;
  }

  public getGameScene(): GameScene {
    return this.gameScene;
  }

  public abstract update(deltaTime: number): void;
  public abstract dispose(): void;
} 